import { cloneDeep, orderBy } from 'lodash';
import Reports from 'pages/ConfigurationsTabs/Reports/Index';

const defaultClaimsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'ceReceivable',
  filters: [],
};
const defaultReports={
currentPage:1,
  pageSize:10,
  order:"desc",
  orderBy:"createddate",
  filters:[]
}
const defaultConfigurations={
  currentPage:1,
  pageSize:10,
  order:"desc",
  orderBy:"createddate",
  filters:[]
}
const defaultViewReports= {
    currentPage:1,
  pageSize:10,
  order:"desc",
  orderBy:"createddate",
  filters:[]
}

const defaultHistory= {
    currentPage:1,
  pageSize:10,
  order:"desc",
  orderBy:"createddate",
  filters:[]
}
const defaultStates = {
  claimsManager: {
    hasFilterd: false,
    search: cloneDeep(defaultClaimsFilter),
    pharmacies: [],
    patients: [],
    claimStatus: {},
    coveredEntity: {},
    pharmacy: {},
    statusname: {},
    searchPatientTerm: '',
    patient: '',
    provider: '',
    searchTerms: {
      coveredEntityID: '',
      pharmacyID: '',
      patientID: '',
      rxNumber: '',
      providerID: '',
      providerFirstName: '',
      startDate: '',
      endDate: '',
      claimStatusID: '',
      pharmacyIds: {},
      claimStatusIds: {}
    },
  },
  configurations: {
    hasFilterd: false,
    search: cloneDeep(defaultConfigurations),
    coveredEntities: [],
    Applications: [],
    ReportType: [],
    coveredEntity: {},
    Application: {},
    ReportType: {},
    searchTerms: {
      coveredEntityIDs: [],
      ApplicationId:{},
      ReportTypeId: [],
      
    }
  },
  reports: {
    hasFilterd: false,
    Search: cloneDeep(defaultReports),
    coveredEntities: [],
    Applications: [],
    ReportType: [],
    coveredEntity: {},
    Application: {},
    ReportType: {},
    SearchTerms: {
      coveredEntityIDs: [],
      ApplicationId:{},
      ReportTypeId: [],
      startDate: '',
      endDate: '',
    }
    },
      viewReports: {
    hasFilterd: false,
    Search: cloneDeep(defaultViewReports),
    Applications: [],
    ReportType: [],
    ReportDetail:[],
    Application: {},
    ReportType: {},
    ReportDetail:{},
    SearchTerms: {
      ApplicationId:"",
      ReportTypeId: "", 
      ReportDetail:"", 
    }
  },
    history: {
    hasFilterd: false,
    Search: cloneDeep(defaultHistory),
    NotificationCenterId : '',
    SearchTerms: {
      NotificationCenterId:''
    }
  },
};

const initialStates = {
  loading: false,
  claimsManager: cloneDeep(defaultStates.claimsManager),
  configuration:cloneDeep(defaultStates.configurations),
  reports:cloneDeep(defaultStates.reports),
  viewReports:cloneDeep(defaultStates.viewReports),
  history:cloneDeep(defaultStates.history)


};

export { initialStates, defaultStates };
